<template>
    <b-card class="station-info--card">
        <b-card-header class="station-info--card-header" >Seguimientos de estaciones y equipos</b-card-header>
        <b-card-body class="station-info--card-body">
            <div class="stations-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="stationField in stationFields">{{ stationField.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <CustomRow
                            v-for="row in rows"
                            :key="row.key"
                            :row="row"
                        ></CustomRow>
                    </tbody>
                </table>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import CustomRow from "./CustomRow";
import {mapGetters} from "vuex";
export default {
    name: "StationsTable",
    components: {CustomRow},
    data(){
        return {
            stationFields: [
                { key: 'state', label: '', },
                { key: 'name', label: 'Nombre', },
                { key: 'format', label: 'Unidad', },
                { key: 'completedPercentage', label: 'Completado', },
                { key: 'quantity', label: 'Uds. a fabricar', },
                { key: 'okQuantity', label: 'Uds. fabricadas', },
                { key: 'delayedQuantity', label: 'Uds. atrasadas', },
                { key: 'stopsTime', label: 'Tiempo de atraso', },
            ],
        }
    },
    props: {
        data:Object,
    },
    mounted(){
    },
    computed: {
        ...mapGetters('order_reference_view',['rows'])
    }

}
</script>

<style scoped lang="scss">
.station-info--card{
    &-body {
        padding: 0;
    }
}
</style>